<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">{{permission}} - Notify Users</legend>
    </div>
  </div>
  <form [formGroup]="notifyUsersForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.permission == 'HHG & FRT' ">
              <label for="bus_type" class="usa-label">Business Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="bus_type" class="usa-select" formControlName="busType" (change)="businessTypeChange($event.target.value)" required>
                <option [value]='' selected disabled>Choose...</option>
                <option value='FRT' >FRT</option>
                <option value='HHG' >HHG</option>
              </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="users_type" class="usa-label">Users Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="users_type" class="usa-select" formControlName="usersType" (change)="usersTypeChange($event.target.value)" required>
                <option [value]='' selected disabled>Choose...</option>
                <option value='agency' >Agency</option>
                <option value='tsp' >TSP</option>
                <option value='tempNonUseTsps' >Temp Non-Use TSPs</option>
                <option value='processingTsps' *ngIf="this.permission == 'FRT' " >Processing TSPs</option>
              </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12"  *ngIf="this.usersType == 'agency'">
              <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="user_sub_type" class="usa-select" formControlName="usersSubType" (change)="userSubTypeChange($event.target.value)" required>
                <option [value]='' selected disabled>Choose...</option>
                <option value='user' >Agency Users</option>
                <option value='ro' >Agency Authorized Officials</option>
                <option value='API' >Agency API Customers</option>
              </select>
            </div>

            <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="(this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps' || this.usersType == 'processingTsps') && this.permission == 'FRT' ">
              <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="user_sub_type" class="usa-select" formControlName="usersSubType"
                      (change)="userSubTypeChange($event.target.value)" required>
                  <option value='' selected disabled>Choose...</option>
                  <option value='user' >TSP Users</option>
                  <option value='ro' >TSP Authorized Officials</option>
              </select>
            </div>

            <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="(this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps') && this.permission == 'HHG' ">
              <label for="user_sub_type" class="usa-label">Users Sub Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="user_sub_type" class="usa-select" formControlName="usersSubType"
                      (change)="userSubTypeChange($event.target.value)" required>
                  <option value='' selected disabled>Choose...</option>
                  <option value='user' >TSP Users</option>
                  <option value='ro' >TSP Authorized Officials</option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="(this.usersType == 'tsp' || this.usersType == 'tempNonUseTsps') && this.permission == 'HHG' ">
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="rfspInclude"  type="checkbox" formControlName="rfspInclude" (click)="rfspIncludeCheck($event)" />
                <label class="usa-checkbox__label" for="rfspInclude" >check to include RFSPs</label>
              </div>
            </div>

          </div>

        </div>
        <!--
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="banner" class="usa-label">Email Banner Image</label>
              <select id="bannerImage" class="maxw-full usa-select" formControlName="bannerImage" (change)="bannerImageChange($event.target.value)">
                  <option value='' selected disabled>Choose...</option>
                  <option *ngFor="let image of images" [value]="image">{{image}} </option>
                  <option value='TMSS_logo.gif' selected>TMSS Logo</option>
                  <option value='TMSS_CTM_logo.gif' >TMSS CTM Logo</option>
                  <option value='TMSS_ERRC_logo.gif'>TMSS ERRC Logo</option>
              </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="busType == 'HHG' || busType == 'FRT'" >
              <div class="usa-checkbox">
                <input class="usa-checkbox__input" id="upload-image" type="checkbox" formControlName="uploadImage" (click)="uploadImageCheck($event)"/>
                <label class="usa-checkbox__label" for="upload-image">check to add a new image to the email banner images list</label>
              </div>
            </div>


            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="uploadImage">
              <app-upload-image [businessType]='busType' (uploadedImage) = 'gotResponseFromUploadImage($event)'></app-upload-image>
            </div>

          </div>
        </div>
        -->
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email" class="usa-label">Email Subject<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" formControlName="emailSubject" id="email_subject" class="usa-input" maxlength="254">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="email_body" class="usa-label">Email Body <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <textarea id="email_body" class="usa-textarea" maxlength="5000" formControlName="emailBody"></textarea>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <app-multi-file-upload  [sentEmails]="sentEmails" (gotUploadedFiles)="updateUploadedFiles($event)"></app-multi-file-upload>
            </div>
            <div class="grid-row grid-gap-0" *ngIf="this.exceededUploadLimit">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <p style="color:red;"><strong>The attached file(s) of total size {{uploadLimit}}MB has exceeded 40 MB limit.</strong></p>
              </div>
            </div>
            <div class="grid-row grid-gap-0" *ngIf="this.withinUploadLimit">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <p style="color:green;"><strong>{{fileCount}} file(s) of total size {{uploadLimit}}MB will be attached to the email.</strong></p>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <button type="button" class="usa-button " [disabled]="this.notifyUsersForm.invalid || this.exceededUploadLimit" (click) = "submit()">Send Email</button>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>
